export default "__VITE_ASSET__Ca5$I6It__"